import { Box, Textarea } from '@chakra-ui/react';
import { isEmpty } from 'lodash';

import { Condition } from 'Component/others';
import { TextRegular, TextSemiBold } from 'UiKit/typography';

import styles from './styles.module.css';
import SkeletonComponent from 'UiKit/skeleton';

const InputTextAreaComponent = ({
  label,
  placeholder,
  onChange,
  value,
  isDisabled,
  isReadOnly,
  error,
  width,
  isRequired,
  register,
  margin,
  className,
  isFetching,
  maxLength = 160,
  textAreaClassName = '',
  isImmutable,
  minLength = 0,
  onBlur,
}) => {
  const isError = !isEmpty(error);

  return (
    <Box
      margin={margin}
      className={`
        ${className}
        ${styles['textarea-component__container']}
        ${isDisabled && styles['textarea-component__container--disabled']}
        ${isReadOnly && styles['textarea-component__container--readonly']}
        ${isError && styles['textarea-component__container--error']}
        ${isImmutable && styles['textarea-component__container--immutable']}
      `}
    >
      <Condition statement={label}>
        <TextSemiBold className={styles['text__title']}>
          {label}{' '}
          <Condition statement={isRequired}>
            <span>*</span>
          </Condition>
        </TextSemiBold>
      </Condition>

      <Condition
        statement={!isFetching}
        fallback={
          <Box className={styles['input-skeleton__container']} width={width}>
            <SkeletonComponent width="40%" height="16px" />
          </Box>
        }
      >
        <Box position={'relative'}>
          <Textarea
            background={isEmpty(value) ? 'white' : 'var(--color-semantic-background)'}
            value={value ?? ''}
            disabled={isDisabled}
            readOnly={isReadOnly || isImmutable}
            placeholder={placeholder}
            onChange={onChange}
            focusBorderColor="transparent"
            className={`${styles['textarea']} ${textAreaClassName}`}
            width={width}
            maxLength={maxLength}
            minLength={minLength}
            onBlur={onBlur}
            resize={isReadOnly ? 'none' : 'vertical'}
            {...register}
          />
        </Box>
      </Condition>

      <Condition statement={isError}>
        <TextRegular className={styles['error__text']}>{error?.message}</TextRegular>
      </Condition>
    </Box>
  );
};

export default InputTextAreaComponent;
